import { getTreeItemPadding } from './types';

interface TreeErrorProps {
  depth: number;
  message: string;
}

export function TreeError({ depth, message }: TreeErrorProps) {
  return (
    <div className="text-xs text-destructive py-1" style={getTreeItemPadding(depth)}>
      {message}
    </div>
  );
}
